import { useEffect, useState, type ChangeEvent } from 'react';
import { NewCheckbox } from '../../PIM/common';
import type { BombiixCellRendererParams } from '../types';

/**
 * Boolean checkbox cell. Toggles optimistically via local state so the tick
 * flips on the same click instead of waiting on the parent's recalc round-trip.
 * Uses the PIM design-system NewCheckbox in its 16px compact variant so cell
 * height stays at the standard 40/52px row height.
 */
function CheckboxCell(params: BombiixCellRendererParams<any, boolean>) {
  const { value, data, colDef, onRowChange, getRowId, disabled } = params;
  const rowId = getRowId ? getRowId(data) : (data as { id?: string | number } | undefined)?.id;
  const field = colDef?.field;

  const [checked, setChecked] = useState<boolean>(Boolean(value));

  useEffect(() => {
    setChecked(Boolean(value));
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    if (rowId !== undefined && field) onRowChange?.(rowId, field, e.target.checked);
  };

  return (
    <label className="cag-checkbox">
      <NewCheckbox size="sm" checked={checked} disabled={disabled} onChange={handleChange} />
    </label>
  );
}

export default CheckboxCell;
